<template>
	<div>
		<div class="mt-4 container-fluid">
			<nav class="navbar navbar-expand-lg navbar-light mb-4">
			 	<h1 class="h3 mb-0 text-gray-800 mr-4">
					Pedidos
			  	</h1>
			  	<button 
					class="navbar-toggler" 
					type="button" 
					data-toggle="collapse" 
					data-target="#navbarSupportedContent" 
					aria-controls="navbarSupportedContent" 
					aria-expanded="false" 
					aria-label="Toggle navigation">
			    	<span class="navbar-toggler-icon"></span>
			  	</button>
			  	<div class="collapse navbar-collapse" id="navbarSupportedContent">
			    	<bsh-nav 
						:tabs="tabs"
						name="pedidoTab" 
						@navChanged="setLink">
					</bsh-nav>
					<div>
						<router-link 
		                    class="btn btn-success ml-2"
		                    v-bind:to="{ name: 'tags' }">
		                    <i class="fas fa-tag mr-2"></i>
		                    Tags
		                </router-link>
						<button 
							class="btn btn-primary ml-2"
							@click="create()">
							Novo
						</button>
					</div>
			  	</div>
			</nav>
			<div class="card">
                <div class="card-header">
			        <div class="text-muted fs-19 mr-2">
			        	<strong>Painel Principal</strong>
			        </div>
		        </div>
		        <div class="card-body">
		            <pedido-table 
		            	@show="show" 
		            	:link="link" 
		            	:key="pedidoTableKey">
		            </pedido-table>
		        </div>
		    </div>
		</div>
		<pedido-create 
			:key="pedidoCreateKey"
			@reload="reload">
		</pedido-create>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				tabs: [
		            {
		              	label: 'Em Produção',
		              	field: '2',
		            },
		            {
		              	label: 'Inicializar',
		              	field: '1'
		            },
		            {
		              	label: 'Finalizado',
		              	field: '3',
		            },
		            {
		              	label: 'Entregue',
		              	field: '4',
		            },
		            {
		            	label: 'Todos',
		              	field: '0',
		            },
				],
				pedidoTableKey: 1,
				pedidoCreateKey: 1,
				link: this.$url+'/api/adm/pedidos/datatable/',
			}
		},
		created(){
			this.setLink('2');
		},
		methods: {
			setLink(tab){
				this.link = this.$url+'/api/adm/pedidos/datatable/'+tab;
				this.pedidoTableKey += 1;
			},
			create(){
				$('#create_pedido').modal('show');
			},
			show(dado_id){
				this.$router.push('/adm/pedidos/show/'+dado_id)
			},
			reload(){
				this.pedidoTableKey += 1;
				this.pedidoCreateKey += 1;
			},
		}
	}
</script>